<app-modal [header]="'redirectAfterAddingInvalidArticle.title' | translate">
  <div modal-body>
    @switch (openType()) {
      @case ('configuration') {
        {{ 'redirectAfterAddingInvalidArticle.openArticleAsNewProjectText' | translate:{'0': articleVO.articleNo} }}
      }
      @case ('ltl-wizard') {
        {{ 'redirectAfterAddingInvalidArticle.openLtlWizardText' | translate }}
      }
      @default {
        {{ 'redirectAfterAddingInvalidArticle.cannot_add' | translate }}
      }
    }
  </div>
  <ng-container modal-footer>
    @if(!!openType()) {
      <button class="btn btn-secondary btn-forward" (click)="close()">{{ 'global.label.no' | translate }}</button>
      <button class="btn btn-primary btn-forward" data-testid="submit" (click)="submit()">{{ 'global.label.yes' | translate }}</button>
    } @else {
      <button class="btn btn-primary btn-forward" (click)="close()">{{ 'global.label.ok' | translate }}</button>
    }
  </ng-container>
</app-modal>
